import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GetAddressesGraphQLResponse, TPECountries, TPEOktaFlags, TPEStates } from '@app/models/thirdparty-documents.model';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '@environments/environment';

const httpOptions = {
  withCredentials: true,
};

@Injectable({
  providedIn: 'root'
})
export class ThirdPartyDocumentsService {
  constructor(
    private readonly http: HttpClient,
    private readonly cookie: CookieService
  ) { }

  getThirdPartyAddressList(): Observable<GetAddressesGraphQLResponse> {
    const endpoint = `${environment.THIRDPARTY_DOCUMENTS.BASE_URL}${environment.THIRDPARTY_DOCUMENTS.GET_ADDRESSES}`;
    return this.http.get<GetAddressesGraphQLResponse>(endpoint, httpOptions);
  }

  getAccounts(): Observable<any> {
    const endpoint = `${environment.THIRDPARTY_DOCUMENTS.BASE_URL}${environment.THIRDPARTY_DOCUMENTS.ACCOUNTS}`;
    return this.http.get<any>(endpoint, httpOptions);
  }

  getStates(): Observable<TPEStates> {
    const endpoint = `${environment.THIRDPARTY_DOCUMENTS.BASE_URL}${environment.THIRDPARTY_DOCUMENTS.STATES}`;
    return this.http.get<TPEStates>(endpoint, httpOptions);
  }

  getCountries(): Observable<TPECountries> {
    const endpoint = `${environment.THIRDPARTY_DOCUMENTS.BASE_URL}${environment.THIRDPARTY_DOCUMENTS.COUNTRIES}`;
    return this.http.get<TPECountries>(endpoint, httpOptions);
  }

  getOktaGroup(): Observable<TPEOktaFlags> {
    const endpoint = `${environment.THIRDPARTY_DOCUMENTS.BASE_URL}${environment.THIRDPARTY_DOCUMENTS.GROUPS}`;
    return this.http.get<TPEOktaFlags>(endpoint, httpOptions);
  }

  addAddress(payload: any): Observable<any> {
    const endpoint = `${environment.THIRDPARTY_DOCUMENTS.BASE_URL}${environment.THIRDPARTY_DOCUMENTS.ADD_ADDRESS}`;
    return this.http.post<any>(endpoint, payload, this.getHttpOptions());
  }

  updateAddress(payload: any): Observable<any> {
    const endpoint = `${environment.THIRDPARTY_DOCUMENTS.BASE_URL}${environment.THIRDPARTY_DOCUMENTS.UPDATE_ADDRESS}`;
    return this.http.put<any>(endpoint, payload, this.getHttpOptions());
  }

  deleteAddress(payload: any): Observable<any> {
    const endpoint = `${environment.THIRDPARTY_DOCUMENTS.BASE_URL}${environment.THIRDPARTY_DOCUMENTS.DELETE_ADDRESS}`;
    return this.http.put<any>(endpoint, payload, this.getHttpOptions());
  }

  private getHttpOptions() {
    return {
      withCredentials: true,
      headers: new HttpHeaders({
        'X-XSRF-TOKEN': this.cookie.get('XSRF-TOKEN')
      })
    };
  }
}
